<template>
  <transition name="c-loading__animation" mode="out-in">
    <div :class="['c-loading', { 'c-loading--is-overlay': isOverlay, 'c-loading--is-inversed': isInversed, 'c-loading--is-overlay-container': isOverlayContainer }]" v-if="isActive" :style="loadingStyles" >
      <div class="c-loading__inner-wrapper">
        <base-spinner class="c-loading__spinner" v-bind="$attrs"></base-spinner>

        <span v-if="canShowLabel" class="c-loading__label">
          <slot>{{$t('loadingStates.busyLoading')}}</slot>
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BaseLoading',

  props: {
    isActive: {
      type: Boolean,
      default: true
    },
    isInversed: {
      type: Boolean,
      default: false
    },
    isOverlay: {
      type: Boolean,
      default: false
    },
    isOverlayContainer: {
      type: Boolean,
      default: false
    },
    canShowLabel: {
      type: Boolean,
      default: true
    },
    borderRadius: {
      type: Number,
      default: null
    }
  },

  computed: {
    loadingStyles () {
      return `border-radius:${this.borderRadius}px`
    }
  }
}
</script>
